export const getUser = (state) => state.firebase.auth.uid;
export const getUserProfile = (state) => state.firebase.profile;
